<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Nova solicitação - {{ requestInfo.title }}</v-toolbar-title>
      </v-toolbar>
      <div v-if="requestInfo.description">{{ requestInfo.description }}</div>
      <br><br>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <v-row v-if="requestInfo.options && requestInfo.options.customer">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.customer"
              v-model="fields.customer.value"
              :rules="[...fields.customer.rules]"
              :items="fields.customer.options"
              :loading="fields.customer.loading"
              :search-input.sync="fields.customer.search"
              :placeholder="'Comece escrevendo o nome do cliente, CPF, telefone ou e-mail'"
              hide-no-data no-filter
              outlined dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.options && requestInfo.options.celebration">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.celebration"
              v-model="fields.celebration.value"
              :rules="[...fields.celebration.rules]"
              :items="fields.celebration.options"
              :loading="fields.celebration.loading"
              :search-input.sync="fields.celebration.search"
              :placeholder="'Comece escrevendo o nome da turma'"
              hide-no-data no-filter
              outlined dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.options && requestInfo.options.participant">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.participant"
              v-model="fields.participant.value"
              :rules="[...fields.participant.rules]"
              :items="fields.participant.options"
              :loading="fields.participant.loading"
              :search-input.sync="fields.participant.search"
              :placeholder="(fields.celebration.value) ? 'Selecione um participante' : 'Escolha uma turma primeiro...'"
              outlined dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.options && requestInfo.options.joined">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.joined"
              v-model="fields.joined.value"
              :rules="[...fields.joined.rules]"
              :items="fields.joined.options"
              :loading="fields.joined.loading"
              :placeholder="(fields.participant.value) ? 'Selecione uma arrecadação' : 'Escolha um participante primeiro...'"
              outlined dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.options && requestInfo.options.fundraising">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.fundraising"
              v-model="fields.fundraising.value"
              :rules="[...fields.fundraising.rules]"
              :items="fields.fundraising.options"
              :loading="fields.fundraising.loading"
              :placeholder="(fields.fundraising.value) ? 'Selecione uma arrecadação' : 'Escolha uma turma primeiro...'"
              outlined dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.options && requestInfo.options.invoice">
          <v-col cols="12" class="py-0">
            <v-autocomplete
              :label="requestInfo.options.invoice"
              v-model="fields.invoice.value"
              :rules="[...fields.invoice.rules]"
              :items="fields.invoice.options"
              :loading="fields.invoice.loading"
              :placeholder="(fields.invoice.value) ? 'Selecione uma fatura' : 'Escolha um participante primeiro...'"
              outlined dense
            ></v-autocomplete>
            {{ this.fields.invoice.value }}
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.aditionalInfo">
          <v-col cols="12" class="py-0">
            <v-textarea
              label="Informações adicionais"
              v-model="fields.aditionalInfo.value"
              :rules="[...fields.aditionalInfo.rules]"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="requestInfo.aditionalInfo">
          <v-col cols="12" class="py-0">
            <v-file-input
              label="Anexos"
              v-model="fields.files.value"
              outlined dense
              @change="fields.files.changed = true"
            />
          </v-col>
        </v-row>
        <h3 class="pt-2 pb-4">Sobre o solicitante</h3>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              label="Solicitante"
              v-model="fields.requester.value"
              :rules="[...fields.requester.rules]"
              placeholder="Quem está solicitantando? O próprio cliente? A comissão? Um parente?"
              type="text"
              outlined dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <v-autocomplete
              label="Canal da solicitação"
              v-model="fields.requesterContactPoint.value"
              :rules="[...fields.requesterContactPoint.rules]"
              :items="fields.requesterContactPoint.options"
              outlined dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-text-field
              label="Identificador do canal"
              v-model="fields.requesterIdentifier.value"
              :rules="[...fields.requesterIdentifier.rules]"
              placeholder="Telefone, email, nome do contato, número do chamado, etc"
              type="text"
              outlined dense
            ></v-text-field>
          </v-col>
        </v-row>
        <br>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'fundraisingForm',
  components: {},
  props: ['id'],
  data: () => ({
    requestInfo: {},
    fields: {
      customer: {
        value: '',
        search: '',
        timeout: null,
        options: [],
        loading: false,
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      celebration: {
        value: '',
        search: '',
        timeout: null,
        options: [],
        loading: false,
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      participant: {
        value: '',
        search: '',
        timeout: null,
        options: [],
        loading: false,
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      fundraising: {
        loading: false,
        value: '',
        options: [],
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      joined: {
        loading: false,
        value: '',
        options: [],
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      invoice: {
        loading: false,
        value: '',
        options: [],
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      aditionalInfo: {
        value: '',
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      files: {
        value: null,
        changed: false,
        fileIds: []
      },
      requester: {
        value: '',
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      requesterContactPoint: {
        value: '',
        options: ['Huggy', 'Whastapp Rafa', 'Whatsapp Suporte', 'Whatsapp Renegociação', 'E-mail', 'Chat'],
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      requesterIdentifier: {
        value: '',
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      },
      sendCopyTo: {
        value: '',
        rules: [
          v => !!v || 'Campo obrigatório'
        ]
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    ...mapGetters(['requestById', 'userEmail'])
  },
  watch: {
    'fields.celebration.search' (val) {
      if (val) {
        if (this.fields.celebration.timeout) {
          clearTimeout(this.fields.celebration.timeout)
        }

        this.fields.celebration.timeout = setTimeout(() => {
          this.getCelebrationSelect(val)
        }, 500)
      }
    },
    'fields.customer.search' (val) {
      if (!!val && val.split(' - ').length < 2) {
        if (this.fields.customer.timeout) {
          clearTimeout(this.fields.customer.timeout)
        }

        this.fields.customer.timeout = setTimeout(() => {
          this.getCustomerSelect(val)
        }, 500)
      }
    },
    'fields.participant.search' (val) {
      if (val) {
        if (this.fields.participant.timeout) {
          clearTimeout(this.fields.participant.timeout)
        }

        this.fields.participant.timeout = setTimeout(() => {
          this.getParticipantSelect(val)
        }, 500)
      }
    },
    'fields.celebration.value' (val) {
      if (this.requestInfo.options) {
        if (this.requestInfo.options.participant) this.getParticipantSelect()
        if (this.requestInfo.options.fundraising) this.getFundraisingSelect()
      }
    },
    'fields.participant.value' (val) {
      const participant = this.fields.participant.options.find(e => e.value === val)
      if (participant && !this.fields.customer.value) this.fields.customer.value = participant.customerId
      if (this.requestInfo.options.joined) this.getJoinedSelect()
      if (this.requestInfo.options.invoice) this.getInvoiceSelect(true)
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    setMask (val, mask) {
      if (!val) {
        return ''
      }
      if (mask === 'document') {
        if (val.length === 11) {
          return val.substr(0, 3) + '.' + val.substr(3, 3) + '.' + val.substr(6, 3) + '-' + val.substr(9, 2)
        } else {
          return val.substr(0, 2) + '.' + val.substr(2, 3) + '.' + val.substr(5, 3) + '/' + val.substr(8, 4) + '-' + val.substr(12, 2)
        }
      }
      if (mask === 'phone') {
        return '(' + val.substr(0, 2) + ') ' + val.substr(2, 1) + ' ' + val.substr(3, 4) + '-' + val.substr(7, 4)
      }
      if (mask === 'invoiceStatus') {
        if (val === 'paid') return 'Pago'
        if (val === 'late') return 'Atrasado'
        if (val === 'pending') return 'Em aberto'
        if (val === 'canceled') return 'Cancelado'
        if (val === 'renegotiated') return 'Renegociado'
        if (val === 'update') return 'Atualizando...'
        if (val === 'cancel') return 'Cancelando...'
        if (val === 'create') return 'Criando...'
        if (val === 'synchronize') return 'Sincronizando...'
        return 'Indefinido'
      }
      if (mask === 'price') {
        if (val || val === 0) {
          let splitValue = parseFloat(val).toFixed(2).toString().split('.')
          let newValue = ''

          for (let i = splitValue[0].length - 1; i >= 0; i--) {
            newValue = splitValue[0][i] + newValue
            if (i > 0 && newValue.replace('.', '').length % 3 === 0) newValue = '.' + newValue
          }

          if (!splitValue[1]) newValue += ',00'
          else if (splitValue[1].length === 1) newValue += ',' + splitValue[1] + '0'
          else newValue += ',' + splitValue[1].substr(0, 2)

          return 'R$ ' + newValue
        }
      }
      return val
    },
    getCustomerSelect (val) {
      this.fields.customer.loading = true
      axios.get('customers?filter[q]=' + val)
        .then(response => {
          this.fields.customer.options = response.data.data.map(e => ({
            value: e.id,
            text: e.name + ' (' + e.nickname + ') - ' + this.setMask(e.person_document, 'document') + ' - ' + this.setMask(e.phone, 'phone') + ' - ' + e.email
          }))
        })
        .finally(() => (this.fields.customer.loading = false))
    },
    getCelebrationSelect (val) {
      this.fields.celebration.loading = true
      axios.get('celebrations?filter[name]=' + val)
        .then(response => {
          this.fields.celebration.options = response.data.data.map(e => ({
            value: e.id,
            text: e.name
          }))
        })
        .finally(() => (this.fields.celebration.loading = false))
    },
    getParticipantSelect (val) {
      this.fields.participant.loading = true
      let endpoint = 'participants?filter[celebration_id]=' + this.fields.celebration.value
      if (val) endpoint += '&filter[q]=' + val
      axios.get(endpoint)
        .then(response => {
          this.fields.participant.options = response.data.data.map(e => ({
            value: e.id,
            text: e.customer.name,
            customerId: e.customer.id
          }))
        })
        .finally(() => (this.fields.participant.loading = false))
    },
    getJoinedSelect () {
      this.fields.joined.loading = true
      axios.get('participants/' + this.fields.participant.value)
        .then(response => {
          this.fields.joined.options = response.data.fundraisings.map(e => ({
            value: e.joined_id,
            text: e.name
          }))
        })
        .finally(() => (this.fields.joined.loading = false))
    },
    getFundraisingSelect () {
      this.fields.fundraising.loading = true
      axios.get('fundraisings?filter[celebration_id]=' + this.fields.celebration.value)
        .then(response => {
          this.fields.fundraising.options = response.data.data.map(e => ({
            value: e.id,
            text: e.name
          }))
        })
        .finally(() => (this.fields.fundraising.loading = false))
    },
    getInvoiceSelect (reset, page) {
      if (reset) this.fields.invoice.options = []
      const newPage = page || 1
      this.fields.invoice.loading = true
      axios.get('invoices?filter[celebration_id]=' + this.fields.celebration.value + '&filter[customer_id]=' + this.fields.customer.value + '&page=' + newPage)
        .then(response => {
          const invoiceOptions = response.data.data.map(e => {
            let text = this.$moment(e.invoice_date, 'YYYY-MM-DD').format('MM/YYYY')
            text += ' - ' + this.setMask(e.total_amount, 'price')
            text += ' (' + this.setMask(e.invoice_status, 'invoiceStatus') + ')'
            let gatewayId = (e.invoice_url && e.invoice_url.split('/')) || ''
            gatewayId = (gatewayId && gatewayId[gatewayId.length - 1]) || ''
            return {
              value: e.id + '|' + gatewayId,
              text
            }
          })
          this.fields.invoice.options = [...this.fields.invoice.options, ...invoiceOptions]
          if (response.data.meta && response.data.meta.last_page > newPage) this.getInvoiceSelect(false, newPage + 1)
        })
        .finally(() => (this.fields.invoice.loading = false))
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        if (this.fields.files.changed) {
          this.sendUploadFiles()
        } else {
          this.sendTicketRequest()
        }
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    },
    sendUploadFiles () {
      const data = new FormData()
      data.append('file', this.fields.files.value)
      this.$store.dispatch('clubhouseApi', { method: 'POST', url: 'files', body: data })
        .then((response) => {
          const fileIds = (Array.isArray(response)) ? response.map(e => e.id) : [response.id]
          this.fields.files.fileIds = fileIds
          this.fields.files.changed = false
          this.sendTicketRequest()
        }).catch(() => {
          this.errorMessage = 'Não foi possivel fazer o upload dos arquivos, tente um tamanho menor ou um outro formato'
          this.sending = false
        })
    },
    sendTicketRequest () {
      let vue = this

      let description = 'Solicitante: ' + this.fields.requester.value + ' (via ' + this.fields.requesterContactPoint.value + ' - ' + this.fields.requesterIdentifier.value + ')\n--------------\n'
      const externalLinks = []
      let fileIds = []

      if (this.requestInfo.options && this.requestInfo.options.customer) {
        description += 'customer: ' + this.fields.customer.value + '\n'
        externalLinks.push('https://support.heppi.io/clientes/' + this.fields.customer.value)
      }
      if (this.requestInfo.options && this.requestInfo.options.celebration) {
        description += 'celebration: ' + this.fields.celebration.value + '\n'
        externalLinks.push('https://support.heppi.io/turmas/' + this.fields.celebration.value)
      }
      if (this.requestInfo.options && this.requestInfo.options.participant) {
        description += 'participant: ' + this.fields.participant.value + '\n'
        externalLinks.push('https://support.heppi.io/participantes/' + this.fields.participant.value)
      }
      if (this.requestInfo.options && this.requestInfo.options.fundraising) {
        description += 'fundraising: ' + this.fields.fundraising.value + '\n'
        externalLinks.push('https://support.heppi.io/' + this.fields.celebration.value + '/arrecadacoes/' + this.fields.fundraising.value)
      }
      if (this.requestInfo.options && this.requestInfo.options.joined) {
        description += 'joined: ' + this.fields.joined.value + '\n'
      }
      if (this.requestInfo.options && this.requestInfo.options.invoice) {
        const ids = this.fields.invoice.value.split('|')
        description += 'invoice: ' + ids.join(' | ') + '\n'
        externalLinks.push('https://support.heppi.io/faturas/' + ids[0])
        if (ids[1]) externalLinks.push('https://fatura.heppi.io/' + ids[1])
      }

      if (this.requestInfo.aditionalInfo) {
        description += '--------------\n'
        description += this.fields.aditionalInfo.value
      }

      if (this.fields.files.fileIds && this.fields.files.fileIds.length > 0) {
        fileIds = this.fields.files.fileIds
      }

      const data = {
        project_id: 468,
        name: this.requestInfo.title,
        labels: [{ 'name': this.userEmail }],
        description: description,
        external_links: externalLinks,
        file_ids: fileIds,
        workflow_state_id: 500000087
      }

      this.$store.dispatch('clubhouseApi', { method: 'POST', url: 'stories', body: data })
        .then(() => {
          setTimeout(() => {
            vue.SET_SNACKBAR({ text: 'Solicitação adicionada' })
            vue.sending = false
            vue.$router.go(-1)
          }, 3000)
        })
        .catch(() => {
          vue.errorMessage = 'Não foi possivel criar o ticket. Por favor tente novamente'
          vue.sending = false
        })
    }
  },
  created () {
    this.requestInfo = (this.id) ? this.requestById(this.id) : {}
    if (Object.keys(this.requestInfo).length === 0) {
      this.SET_SNACKBAR({ text: 'Desculpe, mas esse tipo de solicitação não existe' })
      this.$router.go(-1)
    }
    if (this.requestInfo.aditionalInfo) this.fields.aditionalInfo.value = this.requestInfo.aditionalInfo
  }
}
</script>
